import utils from '../../app/util.js'
// 登录登出
export const loginIn = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/passport/login', data).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
};
export const loginOut = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http('./api/passport/logout', data, 'get').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}
export const forgetPassCode = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/sys/sys-user/forget-pwd/${data.email}`, null, 'put').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const uploadFileApi = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/aishiwei/order-info/uploadPayment/${data.id}`, data.file, 'post', 'json', { isform: true }).then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}

export const forgetPass = (data) => {
  return new Promise(function (resolve, reject) {
    utils.http(`./api/sys/sys-user/update-pwd-email`, data, 'put').then(res => {
      resolve(res)
    }, rej => {
      reject(rej)
    })
  });
}



// WEBPACK FOOTER //
// ./src/deps/apis/login.js